import * as Types from '../constants/Types';
import { PAGINATION } from '../constants/Define';
import VinWonder from '../models/VinWonder';

const initialState = {
    onSubmitting: false,
    isFetching: false,
    isSubmit: false,
    isFetchingUpdate: false,
    isGetItem: false,
    vinWonders: [],
    vinWonderSites: [],
    vinWonderTypes: [],
    vinWonderSessions: [],
    vinWonderZones: [],
    pageSize: PAGINATION.pageSize,
    pageIndex: PAGINATION.pageIndex,
    totalCount: PAGINATION.totalCount,
    detail: {
        vinWonder: new VinWonder()
    }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.VIN_WONDER_LIST_ACTION:
            return { ...state, isFetching: true };
        case Types.PROPERTY_CREATE_ACTION:
            return { ...state, isFetching: true, isSubmit: true };
        case Types.VIN_WONDER_DELETE_ACTION:
            return { ...state, isFetching: true };
        case Types.VIN_WONDER_UPDATE_ACTION:
            return { ...state, isFetching: true, isSubmit: true };
        case Types.VIN_WONDER_UPDATE_SUCCESS:
            return { ...state, isFetching: false, isSubmit: false };
        case Types.VIN_WONDER_GET_UPDATE_ACTION:
            return { ...state, isFetchingUpdate: true, isGetItem: true };
        case Types.VIN_WONDER_SITES_ACTION:
            return { ...state, isFetching: true };
        case Types.VIN_WONDER_TYPES_ACTION:
            return { ...state, isFetching: true };
        case Types.VIN_WONDER_SESSION_ACTION:
            return { ...state, isFetching: true };
        case Types.VIN_WONDER_ZONE_ACTION:
            return { ...state, isFetching: true };
        case Types.VIN_WONDER_LIST_SUCCESS:
            return {
                ...state,
                isFetching: false, isFetched: true,
                vinWonders: action.vinWonders.result,
                pageSize: action.vinWonders.pageSize,
                pageIndex: action.vinWonders.pageIndex,
                totalCount: action.vinWonders.totalCount,
                totalPage: Math.ceil(parseInt(action.vinWonders.totalCount) / parseInt(action.vinWonders.pageSize))
            };
        case Types.VIN_WONDER_GET_UPDATE_SUCCESS:
            return {
                ...state,
                isFetching: false, isFetched: true,
                detail: {
                    vinWonder: action.vinWonder
                }
            };
        case Types.VIN_WONDER_CREATE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.VIN_WONDER_CREATE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.VIN_WONDER_DELETE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.VIN_WONDER_DELETE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.VIN_WONDER_UPDATE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.VIN_WONDER_UPDATE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.VIN_WONDER_SITES_SUCCESS:
            return { ...state, vinWonderSites: action.vinWonderSites.data.data, isFetchingUpdate: false };
        case Types.VIN_WONDER_TYPES_SUCCESS:
            return { ...state, vinWonderTypes: action.vinWonderTypes.data, isFetchingUpdate: false };
        case Types.VIN_WONDER_SESSION_SUCCESS:
            return { ...state, vinWonderSessions: action.vinWonderSession.data.data, isFetchingUpdate: false };
        case Types.VIN_WONDER_ZONE_SUCCESS:
            return { ...state, vinWonderZones: action.vinWonderZone.data.data, isFetchingUpdate: false };
        case Types.VIN_WONDER_CHECK_ACTION:
            return { ...state, isChecked: true };
        case Types.VIN_WONDER_CHECK_SUCCESS:
            return { ...state, isFetchingUpdate: false, isChecked: false, resultCheck: action.resultCheck };
        case Types.VIN_WONDER_RESET:
            return { ...initialState, isFetchingUpdate: false, isChecked: false };
        case Types.VIN_WONDER_CHECK_FAIL:
            return { ...state, message: action.params.message, isSubmit: false };
        case Types.VIN_WONDER_RESET:
            state = initialState;
            return { isFetching: false };
        case Types.VIN_WONDER_FAIL:
            return { ...state, isFetching: false, isFetchingUpdate: false, isSubmit: false, isGetItem: false };
        default:
            return state;
    }
}
